import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { E2PositionsEdit } from "./edit";
import { E2PositionsNew } from "./new";
import { E2PositionsTable } from "./table";

export default function E2Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<E2PositionsEdit />} />
      <Route index element={<E2PositionsTable />} />
      <Route path="new" element={<E2PositionsNew />} />
    </Routes>
  );
}
